import { render, staticRenderFns } from "./vehicleRuleDetails.vue?vue&type=template&id=2f7be406&scoped=true"
import script from "./vehicleRuleDetails.vue?vue&type=script&lang=js"
export * from "./vehicleRuleDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7be406",
  null
  
)

export default component.exports